<template>
    <div>
        <div class="header__mobile--menu-icon" :class="{ 'header__mobile--menu-icon--active': !visible }">
            <svg v-if="!visible" @click="openHandler" width="27" height="14">
                <use xlink:href="/assets/front/img/sprite.svg#icon-mobile-menu"></use>
            </svg>

            <svg v-if="visible" @click="show" width="18" height="18">
                <use xlink:href="/assets/front/img/sprite.svg#icon-close-mobile"></use>
            </svg>
        </div>

        <nav class="header__mobile no-select" :class="{ 'header__mobile--active': visible }" @click="hide">
            <div class="header__mobile-wrapper" @click.stop>
                <ul class="header__mobile-sections header__mobile-sections--border-top" itemscope
                    itemtype="https://schema.org/SiteNavigationElement">
                    <slot></slot>
                </ul>

                <div />
            </div>
        </nav>
    </div>
</template>

<script>
import HeaderLogoutButton from "../HeaderLogoutButton.vue";
import HeaderLoginButton from "../HeaderLoginButton.vue";
import HeaderLogo from "../HeaderLogo.vue";
import HeaderProfile from "../HeaderProfile.vue";
import HeaderLoginButtonRender from "../HeaderLoginButtonRender.vue";
import HeaderPages from "../HeaderPages.vue";

export default {
    name: 'HeaderMobileMenu',
    props: ['sections', 'render', 'partnerLogo'],
    components: {
        HeaderPages,
        HeaderLogoutButton,
        HeaderLoginButton,
        HeaderLoginButtonRender,
        HeaderLogo,
        HeaderProfile
    },
    data() {
        return {
            user: window.laravel.user,
            domain: window.laravel.appUrlByLocale,
            prefix: window.laravel.prefix,
            visible: false,
            profileActive: false
        }
    },
    methods: {
        openHandler() {
            this.$emit('beforeShow');

            this.show();
        },
        show() {
            this.visible = true;

            document.body.style.overflow = 'hidden';
        },
        hide() {
            this.visible = false;

            document.body.style.overflow = '';
        },
        showSection(section) {
            let active = section.active;

            this.hideSections();

            section.active = !active;
        },
        hideSections() {
            this.sections.forEach(section => section.active = false);
            this.profileActive = false;
        },
        showPersonal() {
            this.hideSections();

            this.profileActive = true;
        },
        redirect(href) {
            return location.href = window.laravel.appUrlByLocale + window.laravel.prefix + href;
        },
    },
}
</script>

<style scoped>
.no-select {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
</style>
